export const loadConfirmationDialog = () => import('./confirmation-dialog.component');
